import { render, staticRenderFns } from "./royalty-plan-success.vue?vue&type=template&id=773a6020&scoped=true&"
import script from "./royalty-plan-success.vue?vue&type=script&lang=js&"
export * from "./royalty-plan-success.vue?vue&type=script&lang=js&"
import style0 from "./royalty-plan-success.vue?vue&type=style&index=0&id=773a6020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a6020",
  null
  
)

export default component.exports